import React, { useState, useEffect } from 'react';
import { Typography, Box, Modal, IconButton, useMediaQuery, useTheme } from '@mui/material'; // ➕ useMediaQuery, useTheme
import CloseIcon from '@mui/icons-material/Close'; // ➕ Ikona zamknięcia
import ManagerNavBar from '../../Components/NavigationBar/ManagerNavBar';
import AttendanceListComponent from '../../Components/Manager/Attendance/AttendanceListComponent';
import AttendanceCardComponent from '../../Components/Manager/Attendance/AttendanceCardComponent';
import AttendanceRosterComponent from '../../Components/Manager/Attendance/AttendanceRosterComponent';
import supabase from '../../supabaseClient';
import AttendanceReportComponent from '../../Components/Manager/Attendance/AttendanceReportComponent';
// ✅ Z pliku 2 — nowe komponenty (zakładki)
import AttendanceSummaryReport from './AttendanceSummaryReport';
import EmployeeScheduleView from '../../Components/Manager/Attendance/EmployeeScheduleView';
import AttendanceMobileHeader from '../../Components/Manager/Attendance/AttendanceMobileHeader';
import AttendanceMobileList from '../../Components/Manager/Attendance/AttendanceMobileList';
import AttendanceMobileRow from '../../Components/Manager/Attendance/AttendanceMobileRow';
import AttendanceMobileAbsenceRow from '../../Components/Manager/Attendance/AttendanceMobileAbsenceRow';
import AttendanceEditModal from '../../Components/Manager/Attendance/AttendanceEditModal';
import AttendanceCardSkeleton from '../../Components/Manager/Attendance/AttendanceCardSkeleton';
import { deriveAttendanceDisplay } from '../../Components/Manager/Attendance/attendanceDisplayUtils';


function ManagerGateKeeper() {
  // 📱 wykrywanie mobile (tylko do stylów — logika biznesowa bez zmian)
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // active Tab — pozostaje tylko "Obecności"; activeTab wciąż istnieje, bo
  // dalsze bloki (nieużywane w UI) wciąż go odczytują
  const [activeTab] = useState(0);

  const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString('pl-PL'));
  const [attendance, setAttendance] = useState([]);
  const [loadingAttendance, setLoadingAttendance] = useState(true);
  const [absences, setAbsences] = useState([]);
  const [editTarget, setEditTarget] = useState(null);
  const [idConfig, setIdConfiguration] = useState('');

  // Stan dla podglądu zdjęcia na pełnym ekranie
  const [previewImage, setPreviewImage] = useState(null);

  // filtr załogi (klik w awatar w komponencie roster)
  const [rosterFilter, setRosterFilter] = useState(null);

  // zmiana dni obecności
  const [selectedDate, setSelectedDate] = useState(new Date());
  const onPrevDay = () => setSelectedDate(prev => {
    const d = new Date(prev);
    d.setDate(d.getDate() - 1);
    return d;
  });
  const onNextDay = () => setSelectedDate(prev => {
    const d = new Date(prev);
    d.setDate(d.getDate() + 1);
    return d;
  });
  const onDateChange = (newValue) => {
    if (newValue && newValue.isValid()) {
      setSelectedDate(newValue.toDate());
    }
  };

  //problematyczne rekordy 
  const [problematicRecords, setProblematicRecords] = useState([]);

  // do zmiany dni
  const dateString = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;
  const displayDateLabel = selectedDate.toLocaleDateString('pl-PL', { weekday: 'long' });

  // Statystyki obecności
  const AmountOfCurrentCheckIn = attendance.filter(a => a.check_out === null).length;
  const AmountOfWholeCheckIn = attendance.filter(a => a.check_in !== null).length;

  // aktualny czas bez sekund
  const now = new Date();
  const currentTimeWithoutSec = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

  // Timer - zegar
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString('pl-PL'));
    }, 1000);
    return () => clearInterval(interval);
  }, []);


//sprawdzanie idConfig
  useEffect(() => {
    const init = async () => {
      const { data: sessionData } = await supabase.auth.getSession();
      if (!sessionData.session) return;
      const userId = sessionData.session.user.id;
      const { data: profileData, error: profileError } = await supabase
        .from('profiles')
        .select('id_configuration')
        .eq('id', userId)
        .single();
      if (profileError || !profileData) {
        console.log('Błąd pobierania profilu:', profileError);
        return;
      }
      setIdConfiguration(profileData.id_configuration);
    };
    init();
  }, []);

//Zapytanie do bazy danych o obecności
  const fetchAttendance = async () => {
    if (!idConfig) return;
    setLoadingAttendance(true);

    const dayStart = new Date(selectedDate);
    dayStart.setHours(0, 0, 0, 0);
    const dayEnd = new Date(selectedDate);
    dayEnd.setHours(23, 59, 59, 999);

    const { data, error } = await supabase
        .from('attendance')
        .select(`
            id,
            employee_id,
            check_in,
            check_out,
            id_configuration,
            created_at,
            photo_entry_url,
            photo_exit_url,
            employees(
                name,
                surname
            )
        `)
        .eq('id_configuration', idConfig)
        .gte('check_in', dayStart.toISOString())
        .lte('check_in', dayEnd.toISOString())
        .not('check_in', 'is', null)
        .order('created_at', { ascending: false });

    if (error) {
      console.log('Błąd odświeżania:', error);
      setLoadingAttendance(false);
      return;
    }
  // Mapowanie rekordów i asynchroniczne generowanie podpisanych tokenem linków URL
    try {
      const attendanceWithSignedUrls = await Promise.all(
        data.map(async (attend) => {
          let signedEntryUrl = null;
          let signedExitUrl = null;

          // Link dla zdjęcia wejściowego (ważny 5 minut / 300 sekund)
          if (attend.photo_entry_url) {
            const { data: entryData } = await supabase.storage
              .from('attendance-photos')
              .createSignedUrl(attend.photo_entry_url, 300);
            signedEntryUrl = entryData?.signedUrl || null;
          }

          // Link dla zdjęcia wyjściowego (ważny 5 minut / 300 sekund)
          if (attend.photo_exit_url) {
            const { data: exitData } = await supabase.storage
              .from('attendance-photos')
              .createSignedUrl(attend.photo_exit_url, 300);
            signedExitUrl = exitData?.signedUrl || null;
          }

          return {
            ...attend,
            signedEntryUrl,
            signedExitUrl
          };
        })
      );

      setAttendance(attendanceWithSignedUrls);
    } catch (err) {
      console.error('Błąd podczas generowania linków do zdjęć:', err);
      setAttendance(data);
    } finally {
      setLoadingAttendance(false);
    }
  };

  //zapytanie do bazy w poszukiwaniu problematycznych rekordów (np. brak odbicia na wyjściu)
    const fetchProblematicRecords = async () => {
      if (!idConfig) return;
      const last30Days = new Date();
      last30Days.setDate(last30Days.getDate() - 30);
      const last30DaysString = last30Days.toISOString().split('T')[0]; // Format YYYY-MM-DD
      const {data, error} = await supabase
        .from('attendance')
        .select(`
          id,
          employee_id,
          check_in,
          check_out,
          id_configuration,
          created_at,
          photo_entry_url,
          photo_exit_url,
          employees(
            name,
            surname
          )
        `)
        .eq('id_configuration', idConfig)
        .gte('check_in', `${last30DaysString}T00:00:00`)
      if(error) {
        console.log('Błąd pobierania problematycznych rekordów:', error);
        return;
      }
       const problematic = data.filter(r => {
          const toLocalDateString = (isoString) => {
              const d = new Date(isoString);
              return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
          };

          const today = dateString;
          const checkInDay = toLocalDateString(r.check_in);
          const checkOutDay = r.check_out ? toLocalDateString(r.check_out) : null;
          const forgottenCheckOut = !r.check_out && checkInDay < today;
          const overnightShift = checkOutDay && checkInDay !== checkOutDay;
          return forgottenCheckOut || overnightShift;
      });
      setProblematicRecords(problematic);
      }

  //zapytanie do bazy o urlopy nakładające się na wybrany dzień
  const fetchAbsences = async () => {
    if (!idConfig) return;
    const { data, error } = await supabase
      .from('absences')
      .select('id, absence_start, absence_end, type, employee_id, employees(name, surname)')
      .eq('id_configuration', idConfig)
      .lte('absence_start', dateString)
      .or(`absence_end.gte.${dateString},absence_end.is.null`);
    if (error) {
      console.log('Błąd pobierania urlopów:', error);
      return;
    }
    setAbsences(data || []);
  };

  useEffect(() => {
    fetchAttendance();
  }, [idConfig, selectedDate]);

  useEffect(() => {
    fetchProblematicRecords();
  }, [idConfig]);

  useEffect(() => {
    fetchAbsences();
  }, [idConfig, selectedDate]);

  // czyszczenie filtra załogi przy zmianie dnia
  useEffect(() => {
    setRosterFilter(null);
  }, [selectedDate]);

  return (
    <ManagerNavBar>
      {/* 📱 mniejszy padding boczny na mobile */}
      <Box sx={{ px: 6, py: 2 }}>
      <Typography sx={{ fontSize: '30px', fontWeight: 700, color: 'primary.main', mb: 3 }}>
                    Obecności
                </Typography>

        {/* Obecności */}
        {!isMobile && (
          <Box>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {currentTime}
            </Typography>

            <AttendanceRosterComponent
              idConfig={idConfig}
              dateString={dateString}
              attendance={attendance}
              absences={absences}
              selectedEmployeeId={rosterFilter}
              onSelectEmployee={setRosterFilter}
            />

            {problematicRecords.length > 0 && (
                // 📱 mniejszy padding na mobile
                <Box sx={{ border: '2px solid red', borderRadius: 2, p: { xs: 1, sm: 2 }, mb: 2 }}>
                    <Typography color="error">Wymagają uwagi</Typography>
                    {problematicRecords.map(attend => (
                        <AttendanceCardComponent
                            key={attend.id}
                            attendance={attend}
                            onRefresh={fetchProblematicRecords}
                        />
                    ))}
                </Box>
            )}


            <AttendanceListComponent
              onRefresh={fetchAttendance}
              currentTime={currentTimeWithoutSec}
              idConfig={idConfig}
              onPrevDay={onPrevDay}
              onNextDay={onNextDay}
              dateString={dateString}
              onDateChange={onDateChange}
            />

            {/* ✅ Z pliku 1 — signed URLs zamiast getPublicUrl */}
            {loadingAttendance ? (
              Array.from({ length: 5 }).map((_, i) => (
                <AttendanceCardSkeleton key={i} />
              ))
            ) : attendance.length === 0 && absences.length === 0 ? (
              <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center', py: 4 }}>
                Brak danych. Wyświetlany dzień to {displayDateLabel}
              </Typography>
            ) : (
              attendance
                .filter(attend => !rosterFilter || attend.employee_id === rosterFilter)
                .map(attend => (
                  <AttendanceCardComponent
                    key={attend.id}
                    attendance={attend}
                    photoEntryUrl={attend.signedEntryUrl}
                    photoExitUrl={attend.signedExitUrl}
                    onRefresh={fetchAttendance}
                    // ✅ Przekazanie funkcji otwierającej podgląd obrazu
                    onImageClick={(url) => setPreviewImage(url)}
                  />
                ))
            )}

            {absences.filter(abs => !rosterFilter || abs.employee_id === rosterFilter).length > 0 && (
              <Box sx={{ mt: 3 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
                  Urlop • {absences.filter(abs => !rosterFilter || abs.employee_id === rosterFilter).length}
                </Typography>
                {absences
                  .filter(abs => !rosterFilter || abs.employee_id === rosterFilter)
                  .map(abs => (
                    <AttendanceMobileAbsenceRow key={abs.id} absence={abs} />
                  ))}
              </Box>
            )}
          </Box>
        )}

        {/* Obecności — 📱 kompaktowy widok mobilny */}
        {isMobile && (
          <Box>
            {problematicRecords.length > 0 && (
                <Box sx={{ border: '2px solid red', borderRadius: 2, p: 1, mb: 2 }}>
                    <Typography color="error">Wymagają uwagi</Typography>
                    {problematicRecords.map(attend => (
                        <AttendanceMobileRow
                            key={attend.id}
                            attendance={attend}
                            onClick={(a) => setEditTarget(a)}
                        />
                    ))}
                </Box>
            )}

            <AttendanceMobileHeader
              selectedDateObj={selectedDate}
              dateString={dateString}
              onPrevDay={onPrevDay}
              onNextDay={onNextDay}
              onDateChange={onDateChange}
              currentTime={currentTimeWithoutSec}
              AmountOfCurrentCheckIn={AmountOfCurrentCheckIn}
              AmountOfWholeCheckIn={AmountOfWholeCheckIn}
              onRefreshAttendance={fetchAttendance}
              onRefreshAbsences={fetchAbsences}
              idConfig={idConfig}
            />

            <AttendanceMobileList
              attendance={attendance}
              absences={absences}
              onRowClick={(attend) => setEditTarget(attend)}
              onImageClick={(url) => setPreviewImage(url)}
              loading={loadingAttendance}
              dateLabel={displayDateLabel}
            />

            {editTarget && (
              <AttendanceEditModal
                open={Boolean(editTarget)}
                onClose={() => setEditTarget(null)}
                attendance={editTarget}
                currentTime={currentTimeWithoutSec}
                onRefresh={() => { fetchAttendance(); fetchProblematicRecords(); }}
                {...deriveAttendanceDisplay(editTarget)}
              />
            )}
          </Box>
        )}

         {/* Raport obecności */}
        {activeTab === 4 && (
          <Box>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {currentTime}
              </Typography>
               
              <AttendanceSummaryReport idConfig={idConfig} />
              <EmployeeScheduleView></EmployeeScheduleView>
          </Box>
        )}

          {/* Raport godzin */}
        {activeTab === 5 && (
          <Box>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {currentTime}
            </Typography>
            <AttendanceReportComponent idConfig={idConfig} />
          </Box>
        )}


        {/* Koniec strony */}
      </Box>

      {/* ✅ ESTETYCZNY MODAL DO PODGLĄDU ZDJĘĆ - DUŻY EKRAN */}
      <Modal
        open={Boolean(previewImage)}
        onClose={() => setPreviewImage(null)}
        closeAfterTransition
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 0.85)',
              backdropFilter: 'blur(10px)', // Mocniejszy blur tła
            },
          },
        }}
      >
        <Box
          onClick={() => setPreviewImage(null)} // Zamknij po kliknięciu poza obrazkiem
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            outline: 'none',
            p: { xs: 1, sm: 2 }, // 📱 mniejszy margines wokół zdjęcia
          }}
        >
          {/* Przycisk zamknij w prawym górnym rogu */}
          <IconButton
            onClick={() => setPreviewImage(null)}
            sx={{
              position: 'absolute',
              // 📱 bliżej krawędzi na małym ekranie, żeby nie zasłaniać zdjęcia
              top: { xs: 8, sm: 20 },
              right: { xs: 8, sm: 20 },
              color: '#fff',
              backgroundColor: 'rgba(0,0,0,0.4)',
              '&:hover': { backgroundColor: 'rgba(0,0,0,0.6)' },
            }}
          >
            <CloseIcon fontSize={isMobile ? 'medium' : 'large'} />
          </IconButton>

          {/* Wyświetlany obrazek (Zwiększony na maksa) */}
          {previewImage && (
            <Box
              component="img"
              src={previewImage}
              alt="Podgląd obecności"
              onClick={(e) => e.stopPropagation()} // Zapobiega zamknięciu przy kliknięciu bezpośrednio w zdjęcie
              sx={{
                maxWidth: { xs: '100%', sm: '95%' }, // 📱 pełna szerokość na mobile
                maxHeight: { xs: '90%', sm: '95%' },
                borderRadius: '8px',
                boxShadow: '0px 15px 40px rgba(0,0,0,0.7)',
                objectFit: 'contain',
                animation: 'zoomIn 0.2s cubic-bezier(0.16, 1, 0.3, 1)',
                '@keyframes zoomIn': {
                  from: { transform: 'scale(0.92)', opacity: 0 },
                  to: { transform: 'scale(1)', opacity: 1 },
                },
              }}
            />
          )}
        </Box>
      </Modal>
    </ManagerNavBar>
  )};


export default ManagerGateKeeper;